import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import Button from '4all-ui/components/Button';
import Loader from '4all-ui/components/Loader';
import VariationItem from '../VariationItem';
import { customModalStyles } from '../../helpers/constants';
import * as styles from './style';
import { GRAY_LIGHTER, GRAY_DARKER } from '../../styles/variables';
import { getParentSelector } from '../../helpers/modal';

class SelectVariationsModal extends React.Component {
  state = {
    variation: {},
  };

  shouldUpdateVariations(prevProps) {
    const { variations } = this.props;
    const isStateEmptyAndHasProps = !this.state.variations.length && this.props.variations.length;
    const hasVariationsChanged =
      JSON.stringify(prevProps.variations) !== JSON.stringify(variations);

    return hasVariationsChanged || isStateEmptyAndHasProps;
  }

  selectVariation = variation => {
    if (Object.keys(this.state.variation).length) {
      this.setState(prevState => ({
        variation: prevState.variation.id !== variation.id ? variation : {},
      }));
    } else {
      this.setState({ variation });
    }
  };

  closeModal = () => {
    const { closeModal } = this.props;
    closeModal();
    this.clearVariation();
  };

  saveSelection = () => {
    const { onSubmit, closeModal } = this.props;
    const { variation } = this.state;
    if (Object.keys(variation).length) {
      onSubmit(variation);
    } else {
      closeModal(true);
    }
    this.clearVariation();
  };

  clearVariation = () => {
    this.setState({ variation: [] });
  };

  componentDidUpdate(prevProps) {
    const { variation } = this.props;
    if (
      !Object.keys(this.state.variation).length &&
      JSON.stringify(prevProps.variation) !== JSON.stringify(variation)
    ) {
      this.setState({ variation });
    }
  }

  render() {
    const { isLoading, isOpen, variations } = this.props;
    const { variation } = this.state;
    return (
      <Modal
        ariaHideApp={false}
        isOpen={isOpen}
        style={{
          ...customModalStyles,
          content: {
            ...customModalStyles.content,
            width: '90%',
            maxWidth: '460px',
            height: 'auto',
          },
        }}
        onRequestClose={this.closeModal}
        parentSelector={getParentSelector}
      >
        <styles.Container>
          <styles.Header>
            <styles.Content>
              <styles.Title>Variações Globais</styles.Title>
              <styles.Text>
                Selecione a variação global que você deseja vincular ao seu produto.
              </styles.Text>
            </styles.Content>
          </styles.Header>
          <styles.VariationsList>
            {isLoading ? (
              <styles.FullLoader>
                <Loader size="80px" />
              </styles.FullLoader>
            ) : (
              <styles.Content>
                {variations.map(v => (
                  <styles.VariationItemWrapper
                    key={`select-global-${v.id}`}
                    isSelected={variation.id === v.id}
                    onClick={() => this.selectVariation(v)}
                  >
                    <VariationItem
                      variation={v}
                      noMargin
                      showActions={false}
                      className={`variation-${v.id}`}
                    />
                  </styles.VariationItemWrapper>
                ))}

                {variations.length === 0 && (
                  <styles.StyledEmptyMessage big>
                    Não há variações disponíveis
                  </styles.StyledEmptyMessage>
                )}
              </styles.Content>
            )}
          </styles.VariationsList>
          <styles.Footer>
            <Button
              width="100px"
              height="45px"
              customStyles={{
                border: `1px solid ${GRAY_LIGHTER}`,
                backgroundColor: 'transparent',
                padding: '5px 10px',
                color: GRAY_DARKER,
                ':hover': {
                  backgroundColor: 'transparent',
                },
              }}
              onClick={this.closeModal}
              id="select-variations-modal-close-btn"
            >
              Fechar
            </Button>
            <Button
              onClick={this.saveSelection}
              height="45px"
              width="170px"
              customStyles={{
                padding: '5px 10px',
              }}
              id="select-variations-modal-add-btn"
              disabled={!variation.id}
            >
              Adicionar Variação
            </Button>
          </styles.Footer>
        </styles.Container>
      </Modal>
    );
  }
}

SelectVariationsModal.propTypes = {
  variations: PropTypes.array.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
};

SelectVariationsModal.defaultProps = {
  isOpen: false,
};

export default SelectVariationsModal;



// WEBPACK FOOTER //
// ./src/components/SelectVariationsModal/index.js